module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAhUlEQVRYR2NkGGDAOMD2M4w6YDQERkNgNARGQ2A0BDBCQFlZOeD////1jIyMBtSoqIBmfQCateHu3buJ2MzDcICSktIDoAZ5aliObAYTE5Ph7du3L6CbO/gcAI2CBmAo6FMjFIBR8BEaBQlERQE1LCXFjNFsOBoCoyEwGgKjITAaAgMeAgC7eyIh7jxLyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/minus.png
// module id = 1YRJ
// module chunks = 1